<script lang="ts" setup>
defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
  context: {
    type: [Object, Array],
    default: () => null,
  },
})
</script>

<template>
  <StrapiSlice
    class="ct-richtext-with ct-richtext-with--look"
    :class="{ 'ct-richtext-with--mirrored': slice?.RichtextToTheRight }"
    :slice="slice"
    :index="index"
  >
    <div class="ct-richtext-with__grid">
      <div
        v-if="slice?.Richtext?.length"
        class="ct-richtext-with__richtext"
        :style="`color: ${slice.Color || 'inherit'}`"
        :class="`ct-richtext-with__richtext--${slice.TextAlignmentWithLook || 'center'}`"
      >
        <StrapiBlocksText
          :nodes="slice.Richtext"
        />
      </div>

      <ShopTheLookTile
        class="ct-richtext-with__look"
        :shop-the-look="slice?.Look"
        :lazy="index > 0"
        size="medium"
      />
    </div>

    <!-- <pre>slice: {{ slice.Look }}</pre> -->
  </StrapiSlice>
</template>

<style>
@import url("~layers/app/components/Slices/RichtextWith.css");
@import url("~layers/app/components/Slices/RichtextWithLook.css");
</style>
